import { Box, Typography, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

const styles = {
  section: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    border: 1,
    borderColor: "divider",
    borderRadius: 1,
    p: 2,
  } satisfies SxProps<Theme>,
};

type ApiOrderSectionProps = {
  /**
   * Heading above the section's fields. Left unset by a section whose own first
   * control already names it, such as the stop sections' include checkbox.
   */
  readonly title?: string;
  readonly children: ReactNode;
};

/** The bordered card every section of the API-order form is drawn in. */
const ApiOrderSection = ({ title, children }: ApiOrderSectionProps) => (
  <Box sx={styles.section}>
    {title !== undefined && (
      <Typography variant="subtitle1">{title}</Typography>
    )}
    {children}
  </Box>
);

export default ApiOrderSection;
